import { BaseService } from "./BaseService";
import type {
  OfferGroupExportQuery,
  OfferGroupQuery,
  OfferGroupSummaryResponse,
  OffersAnalyticsRangeQuery,
  RevenueTrendExportQuery,
  RevenueTrendResponse,
  RoomUpgradeSummaryResponse,
  SurfaceTabQuery,
  SurfaceTabResponse,
} from "@/types/analytics-offers";

class AnalyticsOffersService extends BaseService {
  private readonly basePath = "/analytics/offers";

  getSurfaceTab(query: SurfaceTabQuery): Promise<SurfaceTabResponse> {
    return this.get<SurfaceTabResponse>(`${this.basePath}/surface`, query);
  }

  getRoomUpgradeSummary(
    query: OffersAnalyticsRangeQuery,
  ): Promise<RoomUpgradeSummaryResponse> {
    return this.get<RoomUpgradeSummaryResponse>(
      `${this.basePath}/room-upgrade/summary`,
      query,
    );
  }

  getRoomUpgradeRevenueTrend(
    query: OffersAnalyticsRangeQuery,
  ): Promise<RevenueTrendResponse> {
    return this.get<RevenueTrendResponse>(
      `${this.basePath}/room-upgrade/revenue-trend`,
      query,
    );
  }

  exportRoomUpgradeRevenueTrend(query: RevenueTrendExportQuery): Promise<Blob> {
    return this.getBlob(
      `${this.basePath}/room-upgrade/revenue-trend/export`,
      query,
    );
  }

  getGroupSummary(query: OfferGroupQuery): Promise<OfferGroupSummaryResponse> {
    return this.get<OfferGroupSummaryResponse>(`${this.basePath}/group`, query);
  }

  exportGroupSummary(query: OfferGroupExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/group/export`, query);
  }
}

export const analyticsOffersService = new AnalyticsOffersService();
